<template>
  <transition name="message-fade">
    <div v-if="visible" class="expire-wrapper">
      <div class="expire-box">
        <div class="title">{{ title }}</div>
        <div class="content">{{ content }}</div>
        <div v-if="link" class="btn">
          <el-button type="primary" @click="linkTo">{{ btnText }}</el-button>
        </div>
      </div>
    </div>
  </transition>
</template>

<script>
import Vue from 'vue';
import router from '@/router';
import { Button } from 'element-ui';

Vue.use(Button);

export default {
  name: 'expireModal',
  data() {
    return {
      visible: false,
      content: '您的合约已到期，请及时联系销售续约',
      link: '',
      title: '提示',
      btnText: '前往设置规则'
    };
  },
  methods: {
    open() {
      this.visible = true;
    },
    close() {
      this.visible = false;
    },
    linkTo() {
      this.link && router.push(this.link);
    }
  }
};
</script>

<style lang="scss" scoped>
.expire-wrapper {
  position: fixed;
  top: 48px;
  left: 240px;
  z-index: 999;
  width: calc(100vw - 240px);
  height: calc(100vh - 48px);
  background-color: rgba(0, 0, 0, 0.5);

  .expire-box {
    position: absolute;
    top: 40%;
    left: 50%;
    z-index: 999;
    width: 380px;
    transform: translate3d(-50%, -50%, 0);
    background-color: #fff;
    border-radius: 4px;
    border: 1px solid #ebeef5;
    font-size: 18px;
    box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);

    .title {
      padding: 15px 15px 10px;
      font-size: 18px;
      font-weight: 600;
      text-align: center;
    }

    .content {
      padding: 10px 50px 30px;
      color: #606266;
      font-size: 14px;
      text-align: center;
    }
  }

  .btn {
    display: flex;
    justify-content: center;
    align-items: center;
    margin-bottom: 30px;
  }
}

.message-fade-enter-active,
.message-fade-leave-active {
  transition: all 0.3s;

  .expire-box {
    transition: all 0.3s;
  }
}

.message-fade-enter,
.message-fade-leave-to {
  opacity: 0;

  .expire-box {
    // transform: translate3d(-50%, -80%, 0);
  }
}
</style>
